import { useState } from 'react';
import { Pencil, Trash2, Check } from 'lucide-react';

const nameOf = (a) => String(a.creditor_name || a.display_name || 'Account').replace(/\s*[-–]\s*\d{1,2}(?:[-/]\d{1,2})?[-/]\d{2,4}.*$/, '').trim();

// Accounts already in a section, each editable in place or removable.
export default function SectionAccountList({ num, accounts, onUpdate, onRemove }) {
  const [editing, setEditing] = useState(null);
  if (!accounts.length) return null;
  const inp = 'h-8 rounded-md bg-zinc-900 border border-zinc-600 px-2 text-xs text-white';
  return (
    <div className="mt-3 space-y-1.5" data-testid={`section-accounts-${num}`}>
      {accounts.map((a) => (
        <div key={a.id} className="rounded-md bg-zinc-900/70 border border-zinc-700 px-2 py-1.5" data-testid={`section-acct-${num}-${a.id}`}>
          {editing === a.id ? (
            <div className="grid grid-cols-1 sm:grid-cols-[1fr_110px_110px_auto] gap-2 items-center">
              <input className={inp} defaultValue={nameOf(a)} onChange={(e) => { onUpdate(a.id, 'creditor_name', e.target.value); onUpdate(a.id, 'display_name', e.target.value); }} data-testid={`section-acct-name-${a.id}`} placeholder="Creditor" />
              <input className={inp} defaultValue={a.date_fraud_began || a.date_opened || ''} onChange={(e) => { onUpdate(a.id, 'date_fraud_began', e.target.value); onUpdate(a.id, 'date_opened', e.target.value); }} data-testid={`section-acct-date-${a.id}`} placeholder="MM-YYYY" />
              <input className={inp} inputMode="decimal" defaultValue={a.balance || ''} onChange={(e) => onUpdate(a.id, 'balance', e.target.value.replace(/[^\d.]/g, ''))} data-testid={`section-acct-balance-${a.id}`} placeholder="Balance" />
              <button type="button" onClick={() => setEditing(null)} className="h-8 px-3 rounded-md bg-green-600 hover:bg-green-500 text-white text-xs font-bold flex items-center justify-center gap-1" data-testid={`section-acct-done-${a.id}`}>
                <Check className="w-3.5 h-3.5" />Done
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <span className="flex-1 min-w-0 text-xs text-zinc-100 break-words">
                <b>{nameOf(a)}</b>
                {(a.date_fraud_began || a.date_opened) && <span className="text-zinc-400"> · {a.date_fraud_began || a.date_opened}</span>}
                <span className="text-green-400"> · ${Number(a.balance || 0).toLocaleString()}</span>
              </span>
              <button type="button" onClick={() => setEditing(a.id)} className="p-1.5 rounded text-blue-300 hover:bg-blue-500/20" title="Edit account" data-testid={`section-acct-edit-${a.id}`}>
                <Pencil className="w-4 h-4" />
              </button>
              <button type="button" onClick={() => window.confirm(`Delete ${nameOf(a)} from Section ${num}?`) && onRemove(a.id)} className="p-1.5 rounded text-red-400 hover:bg-red-500/20" title="Delete account" data-testid={`section-acct-delete-${a.id}`}>
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
